/** Default layout ID for all layout sections */
export const DEFAULT_LAYOUT_ID = 'default';

export const OPTIONS_LAYOUT_ID = 'options-space';
export const OPTIONS_LAYOUT_TEMPLATE_ID = 'options-template';

export const CARE_ORDERS_LAYOUT_ID = 'care-orders-space';
export const CARE_ORDERS_LAYOUT_TEMPLATE_ID = CARE_ORDERS_LAYOUT_ID;

export const MANUAL_RFQS_LAYOUT_ID = 'manual-rfqs-space';
export const MANUAL_RFQS_LAYOUT_TEMPLATE_ID = MANUAL_RFQS_LAYOUT_ID;

export const ORDER_BOOKS_LAYOUT_ID = 'orderBooks';
export const ORDER_BOOKS_LAYOUT_TEMPLATE_ID = ORDER_BOOKS_LAYOUT_ID;

export const CHART_VIEWS_LAYOUT_ID = 'symbolViews';
export const CHART_VIEWS_LAYOUT_TEMPLATE_ID = CHART_VIEWS_LAYOUT_ID;
